/**
 * Same auth router as legacy `/auth/*`, mirrored under `/api/v1/auth/*` on pks-bff.
 * Atlas calls this prefix so HTTPS edges that forward only `/api/*` still reach login/refresh
 * (`https://atlas.mavr.finance/auth/login` 404 fixes without redeploying every broken edge).
 */
export const AUTH_API_PREFIX = "/api/v1/auth";
